"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isFunction = _interopRequireDefault(require("transmute/isFunction"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _Promptable = _interopRequireDefault(require("UIComponents/decorators/Promptable"));

var _PromiseHandlers = require("UIComponents/core/PromiseHandlers");

var _DeleteDialog = _interopRequireDefault(require("customer-data-ui-utilities/dialog/DeleteDialog"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var prompt = (0, _Promptable.default)(_DeleteDialog.default);

var _default = function _default(props) {
  var confirmLabel = props.confirmLabel,
      rejectLabel = props.rejectLabel,
      message = props.message,
      match = props.match,
      matchLabel = props.matchLabel,
      title = props.title,
      gdprEnabled = props.gdprEnabled,
      gdprDeletePossible = props.gdprDeletePossible,
      isScopedForGdprDelete = props.isScopedForGdprDelete,
      objectType = props.objectType,
      dialogBody = props.dialogBody,
      dialogNote = props.dialogNote,
      hasNoFilters = props.hasNoFilters,
      gdprNote = props.gdprNote;
  var callback = (0, _isFunction.default)(props.callback) ? props.callback : _emptyFunction.default;
  var onReject = props.onReject || _PromiseHandlers.rethrowError;
  prompt({
    confirmLabel: confirmLabel,
    gdprEnabled: gdprEnabled && objectType === _ObjectTypes.CONTACT,
    gdprDeletePossible: gdprDeletePossible,
    isScopedForGdprDelete: isScopedForGdprDelete,
    rejectLabel: rejectLabel,
    message: message,
    match: match,
    matchLabel: matchLabel,
    title: title,
    dialogBody: dialogBody,
    dialogNote: dialogNote,
    onReject: onReject,
    hasNoFilters: hasNoFilters,
    objectType: objectType,
    gdprNote: gdprNote
  }).then(callback, onReject).done();
};

exports.default = _default;
module.exports = exports.default;